import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withState } from 'recompose';
import ActivityGroupList from './ActivityGroupList';

const getActivityGroupsFromCoach = (clubActivityGroups, coach) => {
  const groupsActivities = Object.values(clubActivityGroups);

  const groupsFromCoach = groupsActivities.filter(group =>
    group.activityIdList.some(id => coach.activityIds.includes(id))
  );

  return groupsFromCoach;
};

const mapStateToProps = ({ entities }) => ({
  clubActivityGroups: entities.activityGroups
});

function componentWillMount() {
  const { clubActivityGroups, coach, setActivityGroups } = this.props;
  const getActivityGroups = Object.keys(coach).length ? getActivityGroupsFromCoach(clubActivityGroups, coach) : [];

  setActivityGroups(getActivityGroups);
}

// use for coach panel
function componentWillReceiveProps(nextProps) {
  const { coach: nextCoach } = nextProps;
  const { clubActivityGroups, coach, setActivityGroups } = this.props;
  if (nextCoach && nextCoach !== coach) {
    const getActivityGroups = getActivityGroupsFromCoach(clubActivityGroups, nextCoach);

    setActivityGroups(getActivityGroups);
  }
}

export default compose(
  withProps({ itemInCoach: true }),
  connect(mapStateToProps),
  withState('activityGroups', 'setActivityGroups', []),
  lifecycle({ componentWillMount, componentWillReceiveProps })
)(ActivityGroupList);



// WEBPACK FOOTER //
// ./src/components/ActivityGroupList/CoachActivityGroupListContainer.js